import _ from 'lodash'
import { first } from 'rxjs/operators'

import { Alias, LinkOperator, RequestCriteriaResourceInputInterfaceTypes, RequestSearchInputResource } from '@skinsoft/types'
import { SEARCH_TYPES } from '@skinsoft/const'
import { AliasOfflineDataFetcher } from '@skinsoft/offline'
import { EntityDataStore } from '@skinsoft/entity-data-store'
import { UnvalidEmptyArrayError } from './errors'

export class AliasDataStore extends EntityDataStore<Alias> {
    public static getInstance() {
        if (!AliasDataStore.instance) {
            AliasDataStore.instance = new AliasDataStore()
        }

        return AliasDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$aliasDataStore = AliasDataStore.getInstance()
        Vue.prototype.$collaboratorDataStore = AliasDataStore.getInstance()
    }

    private static instance: AliasDataStore = null as any;

    constructor() {
        super('aliases', [SEARCH_TYPES.alias])
    }


    public getCollaboratorByUserId(userId: string) {
        if (window.navigator.onLine) {
            return this.proxy.fetch(`${this.endpoint}/byUser/${userId}`)
                .pipe(first())
        } else {
            return (this.offlineDataFetcher as unknown as AliasOfflineDataFetcher).getByUser(userId)
        }
    }

    protected initializeDataFetcher() {
        // @ts-ignore
        this.offlineDataFetcher = new AliasOfflineDataFetcher()
    }

    protected initializeDataPusher() {
        //throw new Error('Method not implemented.')
    }

    /**
     * 
     * @param tags 
     * @throws UnvalidEmptyArrayError
     * @returns 
     */
    public getTagsCriteria(tags: string[]): RequestSearchInputResource {
        if(tags.length) {
            const criteriaBluePrint = {
                type: "criteria",
                entityField: "5c3c43e88b87bc0001e13a19",
                operator: "equals",
                value: {
                    refId: "",
                    path: "/",
                    type: "path",
                    searchAlternative: false,
                    searchOnChild: false
                },
            }

            const result: RequestSearchInputResource = {
                leftCriteria: (_.cloneDeep(criteriaBluePrint)) as any,
                type: RequestCriteriaResourceInputInterfaceTypes.REQUEST_SEARCH,
            };
            (result as any).leftCriteria.value.refId = tags[0];
            (result as any).leftCriteria.value.path += tags[0]
    
            if(tags.length > 1) {
                for(const tag of tags.slice(1)) {
                    if(result.rightCriteria) {
                        result.leftCriteria = _.cloneDeep(result)
                    }
                    
                    result.linkOperator = LinkOperator.OR
                    result.rightCriteria = _.cloneDeep(criteriaBluePrint) as any
                    (result as any).rightCriteria.value.refId = tag;
                    (result as any).rightCriteria.value.path += tag
                }
            }

            return result
        }

        throw new UnvalidEmptyArrayError()
    }
}


